import SearchDescription from './SearchDescription';

export default SearchDescription;
